export default __webpack_public_path__ + "96adedf4e489c9200f0a33bae686ccbb.png";